export default {"src":"/_next/static/media/cutout.a8f7a575.svg","height":30,"width":21,"blurWidth":0,"blurHeight":0};